import { QueryFeature } from '../../../../../config/queryClient';

enum QueryKey {
  PersonalFinanceTemplates = 'PersonalFinanceTemplates',
}

export const queryKeys = {
  personalFinanceTemplates: () => [QueryFeature.Settings, QueryKey.PersonalFinanceTemplates],
};
